module.exports = __webpack_public_path__ + "static/home-6-1-7747e718dccd3b7b6503ca27e1bb473b.png";